const FinalCTASection = () => {
  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center">
          {/* Small heading */}
          <p className="text-gray-600 text-sm uppercase tracking-wider mb-4">
            GET STARTED NOW
          </p>

          {/* Main heading */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
            <span className="text-blue-500">Contact iSolve RCM Today</span>{' '}
            <span className="text-gray-900">To Get A Medical Billing Services For Your Practice</span>
          </h2>

          {/* Description */}
          <p className="text-gray-600 text-base lg:text-lg max-w-3xl mx-auto mb-8 leading-relaxed">
            Our skilled medical billing services are designed to make your workflow simpler, reduce claim denials, and increase revenue.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg">
              Unblock Your Price
            </button>
            <button className="bg-white hover:bg-gray-50 text-blue-600 font-bold px-8 py-4 rounded-lg border-2 border-blue-600 transition-colors">
              Get a free consultation
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FinalCTASection;
